import React, { useState, useEffect } from 'react';
import StockService from '../../../services/stockService';
import './CompanyDescription.css';

const CompanyDescription = ({ symbol }) => {
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (!symbol) return;
      
      setLoading(true);
      setError(null);
      
      try {
        console.log('📊 Fetching company description for:', symbol);
        const data = await StockService.getStockInfo(symbol);
        console.log('📊 Company description received:', data);
        setCompanyData(data);
      } catch (err) {
        console.error('❌ Error fetching company description:', err);
        setError('Failed to fetch company data');
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [symbol]);

  if (loading) {
    return (
      <div className="company-description">
        <div className="loading-placeholder">
          <div className="loading-spinner">⏳</div>
          <p>Loading company information...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="company-description">
        <div className="error-message">
          <span>❌</span>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!companyData) {
    return (
      <div className="company-description">
        <div className="no-data">
          <p>No company data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="company-description">
      <div className="company-header">
        <h3>About {companyData.name || companyData.symbol}</h3>
      </div>
      
      {companyData.description && (
        <div className="company-overview">
          <p className="company-summary">{companyData.description}</p>
        </div>
      )}
    </div>
  );
};

export default CompanyDescription;

